import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

const TONES = {
  critical: "border-red-500/50",
  action: "border-amber-400/40",
  warning: "border-yellow-400/40",
  neutral: "border-stone-100/10",
};

/**
 * Compact dashboard summary card: title, small stat rows, optional extra
 * content, and a full-width link to the existing management page.
 */
export default function AdminSummaryCard({ title, tone = "neutral", stats = [], actionTo, actionLabel, children }) {
  return (
    <section className={`flex flex-col rounded-2xl border bg-zinc-900/60 p-4 sm:p-5 ${TONES[tone] || TONES.neutral}`}>
      <h3 className="font-display text-xl text-stone-100">{title}</h3>
      {stats.length > 0 && (
        <dl className="mt-3 space-y-1 text-sm">
          {stats.map(({ label, value, valueClass = "text-stone-200" }) => (
            <div key={label} className="flex items-center justify-between gap-3">
              <dt className="text-stone-400">{label}</dt>
              <dd className={`font-semibold ${valueClass}`}>{value}</dd>
            </div>
          ))}
        </dl>
      )}
      {children}
      {actionTo && actionLabel && (
        <Link to={actionTo} className="mt-auto block pt-4">
          <Button
            variant="outline"
            className="w-full bg-transparent border-stone-100/15 text-stone-200 hover:bg-stone-100/5"
          >
            {actionLabel}
          </Button>
        </Link>
      )}
    </section>
  );
}
